import Toggleable from './toggleable'

export default {
    mixins: [Toggleable],
    data: () => ({
        defaultData: {}, //  Da sovrascrivere in tutti i componenti che usano questo mixin
        form: {},
        edit: false,
        sending: false
    }),
    created () {
        this.initializeForm({})
    },
    methods: {
        initializeForm (data) {
            this.form = Object.assign({}, this.defaultData, data)
            this.afterInitialize(data)
        },
        afterInitialize: (data) => ({}),
        reset () {
            this.initializeForm({})
            this.afterReset()
        },
        afterReset: () => ({}),
        //  Possibilità di impostare dati iniziali quando si crea un nuovo elemento
        showCreate (val = {}) {
            this.edit = false
            this.initializeForm(val)
            this.isActive = true
        },
        showEdit (val) {
            this.edit = true
            this.initializeForm(val)
            this.isActive = true
        },
        onSuccess (message = this.$t('messaggi.successo')) {
            this.sending = false
            this.isActive = false
            this.$snackbar.show(message, 'success')
            this.$emit('success')
        },
        onError (message = this.$t('errori.server')) {
            this.sending = false
            this.$snackbar.show(message, 'error')
            this.$emit('error')
        }
    }
}
